import { render, staticRenderFns } from "./new-subbucket-folder.html?vue&type=template&id=6a8c1663&scoped=true&"
import script from "./new-subbucket-folder.js?vue&type=script&lang=js&"
export * from "./new-subbucket-folder.js?vue&type=script&lang=js&"
import style0 from "./new-subbucket-folder.scss?vue&type=style&index=0&id=6a8c1663&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8c1663",
  null
  
)

export default component.exports